import clsx from "clsx";
import { useRouter } from "next/router";
import { Control, Controller } from "react-hook-form";
import OptionCard from "../OptionCard";
import ToggleOptionCardGroup from "../ToggleOptionCardGroup";
import { FieldValues, FormFieldDefinition } from "./interfaces";

export interface ToggleButtonFieldProps<T extends FieldValues> {
  fieldDefinition: FormFieldDefinition<T>;
  control: Control<T>;
  onSubmit: any;
}

const ToggleButtonField = <T extends FieldValues>({
  fieldDefinition,
  control,
  onSubmit,
}: ToggleButtonFieldProps<T>) => {
  const router = useRouter();
  return (
    <Controller
      control={control}
      name={fieldDefinition.name}
      rules={fieldDefinition.rules}
      defaultValue={fieldDefinition.defaultValue}
      render={({ field }) => (
        <ToggleOptionCardGroup
          className="grid grid-cols-12 gap-2s"
          {...field}
          label={fieldDefinition.label}
        >
          {fieldDefinition.options?.map((option, index) => (
            <OptionCard
              className={clsx("col-span-10 col-start-2 m:col-start-auto", {
                "m:col-span-4": option.columns === 4,
                "m:col-span-12": option.columns === 12,
                "m:col-span-6": !option.columns,
              })}
              image={option.image}
              key={index}
              value={option.value}
              onClick={(e) => {
                if (option.href) {
                  e.preventDefault();
                  router.push(option.href);
                } else if (option.submit !== false) {
                  setTimeout(() => onSubmit(), 400);
                }
              }}
            >
              {option.label}
            </OptionCard>
          ))}
        </ToggleOptionCardGroup>
      )}
    />
  );
};

export default ToggleButtonField;
